module.exports = __webpack_public_path__ + "static/img/ba_icon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ba_icon.png
// module id = mnq+
// module chunks = 0